<ng-container *ngIf="steps">
    <app-card-info-steps 
        infoTitle="Personalize a aparência dos seus orçamentos"
        infoDescription="Logo, cores e dados da empresa entram em todos os orçamentos que você enviar"
        [compact]="true"
        [steps]="steps"
        >

        <app-config-step 
            title="Adicione sua logo" 
            key="has_logo"
            [isComplete]="!!steps.has_logo" 
            skipTitle="Pular"
            (onSkip)="skipSteps($event)"
            (onAction)="onItemClick($event)">
        </app-config-step>


        <app-config-step
            title="Complete os dados da empresa"
            key="has_enterprise_data"
            [isComplete]="!!steps.has_enterprise_data"
            skipTitle="Pular"
            (onSkip)="skipSteps($event)"
            (onAction)="onItemClick($event)">
        </app-config-step>


        <app-config-step
            title="Ajuste as cores"
            key="has_layout_colors"
            [isComplete]="!!steps.has_layout_colors"
            skipTitle="Pular"
            (onSkip)="skipSteps($event)"
            (onAction)="onItemClick($event)">
        </app-config-step>

        <app-config-step 
            title="Adicione o endereço da sua empresa" 
            key="has_address"
            [isComplete]="!!steps.has_address" 
            skipTitle="Pular"
            (onSkip)="skipSteps($event)"
            (onAction)="onItemClick($event)">
        </app-config-step>

        <app-config-step 
            title="Adicione as Condições Gerais" 
            key="has_terms_and_conditions"
            [isComplete]="!!steps.has_terms_and_conditions" 
            skipTitle="Pular"
            (onSkip)="skipSteps($event)"
            (onAction)="onItemClick($event)">
        </app-config-step>

        <app-config-step
            title="Adicione a descrição padrão"
            key="has_default_proposal_description"
            [isComplete]="!!steps.has_default_proposal_description"
            skipTitle="Pular"
            (onSkip)="skipSteps($event)"
            (onAction)="onItemClick($event)">
        </app-config-step>

    </app-card-info-steps>
</ng-container>
